import { render, staticRenderFns } from "./PartnerLogosLayout.vue?vue&type=template&id=847a01a0&scoped=true&"
import script from "./PartnerLogosLayout.vue?vue&type=script&lang=js&"
export * from "./PartnerLogosLayout.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogosLayout.vue?vue&type=style&index=0&id=847a01a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847a01a0",
  null
  
)

export default component.exports